// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.barList_figure__YICJo {
  margin: 0;
  container-type: inline-size;
  font-family: var(--font-sans);
}
.barList_table__cIrDd {
  width: 100%;
  border-collapse: collapse;
}
.barList_caption__qd7-9 {
  caption-side: top;
  padding: 0 0 var(--space-4);
  text-align: left;
  font-size: 1.15rem;
  font-weight: 500;
  color: var(--color-text);
}
.barList_row__OJPq- {
  border-top: 1px solid var(--color-border);
}
.barList_label__XZ-qf {
  width: 40%;
  padding: 0.7rem var(--space-3) 0.7rem 0;
  font-size: 0.9rem;
  font-weight: 400;
  color: var(--color-text);
  text-align: left;
  vertical-align: middle;
}
.barList_cell__5jKrh {
  padding: 0.7rem 0;
  display: flex;
  align-items: center;
  gap: var(--space-3);
}
.barList_track__N\\+Ejp {
  flex: 1 1;
  min-width: 0;
  height: 18px;
  display: flex;
  align-items: center;
}
.barList_bar__DzlTw {
  display: block;
  height: 18px;
  min-width: 4px;
  background: var(--color-slate);
  border-radius: 0 4px 4px 0;
  transform-origin: left;
  transition: background var(--dur-fast) ease;
}
.barList_row__OJPq-:hover .barList_bar__DzlTw {
  background: var(--color-ink);
}
.barList_value__ZGUyD {
  flex: none;
  width: 3rem;
  text-align: right;
  font-size: 0.95rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--color-text);
}
.barList_note__-hvHe {
  margin-top: var(--space-3);
  font-size: var(--text-caption);
  color: var(--color-text-muted);
}
@container (max-width: 30rem) {
  .barList_row__OJPq- {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    padding: 0.55rem 0;
  }
  .barList_label__XZ-qf {
    width: auto;
    padding: 0 0 0.3rem;
  }
  .barList_cell__5jKrh {
    padding: 0;
  }
}
.barList_srOnly__1sA96 {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/BAR_LIST/barList.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".figure {\n  margin: 0;\n  container-type: inline-size;\n  font-family: var(--font-sans);\n}\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.caption {\n  caption-side: top;\n  padding: 0 0 var(--space-4);\n  text-align: left;\n  font-size: 1.15rem;\n  font-weight: 500;\n  color: var(--color-text);\n}\n.row {\n  border-top: 1px solid var(--color-border);\n}\n.label {\n  width: 40%;\n  padding: 0.7rem var(--space-3) 0.7rem 0;\n  font-size: 0.9rem;\n  font-weight: 400;\n  color: var(--color-text);\n  text-align: left;\n  vertical-align: middle;\n}\n.cell {\n  padding: 0.7rem 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n.track {\n  flex: 1;\n  min-width: 0;\n  height: 18px;\n  display: flex;\n  align-items: center;\n}\n.bar {\n  display: block;\n  height: 18px;\n  min-width: 4px;\n  background: var(--color-slate);\n  border-radius: 0 4px 4px 0;\n  transform-origin: left;\n  transition: background var(--dur-fast) ease;\n}\n.row:hover .bar {\n  background: var(--color-ink);\n}\n.value {\n  flex: none;\n  width: 3rem;\n  text-align: right;\n  font-size: 0.95rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--color-text);\n}\n.note {\n  margin-top: var(--space-3);\n  font-size: var(--text-caption);\n  color: var(--color-text-muted);\n}\n@container (max-width: 30rem) {\n  .row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    padding: 0.55rem 0;\n  }\n  .label {\n    width: auto;\n    padding: 0 0 0.3rem;\n  }\n  .cell {\n    padding: 0;\n  }\n}\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"figure": `barList_figure__YICJo`,
	"table": `barList_table__cIrDd`,
	"caption": `barList_caption__qd7-9`,
	"row": `barList_row__OJPq-`,
	"label": `barList_label__XZ-qf`,
	"cell": `barList_cell__5jKrh`,
	"track": `barList_track__N+Ejp`,
	"bar": `barList_bar__DzlTw`,
	"value": `barList_value__ZGUyD`,
	"note": `barList_note__-hvHe`,
	"srOnly": `barList_srOnly__1sA96`
};
export default ___CSS_LOADER_EXPORT___;
